import { render, staticRenderFns } from "./ProjectPhasesWizard.vue?vue&type=template&id=e6d3cdc2"
import script from "./ProjectPhasesWizard.vue?vue&type=script&lang=js"
export * from "./ProjectPhasesWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports